import { FC, Suspense } from "react";
import { IconMap } from "../lib/const";
import { WebShopIconProps } from "../lib/type";
import { Box } from "@mui/material";
import Icon from "../../Icon";

const WebShopIcon: FC<WebShopIconProps> = ({
  name,
  color,
  fill,
  width,
  height,
  className,
  strokeWidth = 1,
  ...rest
}) => {
  if (!name) return null;
  const IconComponent = IconMap[name as keyof typeof IconMap];

  if (!IconComponent) {
    return (
      <Icon
        name={name as any}
        size={width}
        color={fill || color}
        strokeWidth={strokeWidth}
        className={className}
        {...rest}
      />
    );
  }

  return (
    <Suspense fallback={<Box style={{ width, height }} />}>
      <IconComponent
        color={color}
        width={width as number}
        height={height as number}
        fill={fill}
        className={className}
        strokeWidth={strokeWidth}
        {...rest}
      />
    </Suspense>
  );
};

export default WebShopIcon;
